function getColumnCount(grid) {
  const cols = window.getComputedStyle(grid).gridTemplateColumns;
  if (!cols || cols === 'none') return 0;
  return cols.trim().split(/\s+/).length;
}

function positionBreakers(grid) {
  const breakers = [...grid.querySelectorAll('.product-breaker')];
  if (!breakers.length) return;

  const colCount = getColumnCount(grid);
  if (!colCount) return;

  const colKey = colCount <= 2 ? 'col2' : colCount === 3 ? 'col3' : 'col4';

  // Reset: hide all breakers and move them to end of grid
  breakers.forEach((breaker) => {
    breaker.style.display = 'none';
    breaker.style.gridColumn = '';
    grid.appendChild(breaker);
  });

  // Sort ascending so each breaker is placed in order — earlier breakers
  // are already in the grid when later ones are positioned, so their index
  // counts correctly against the live item list (products + placed breakers).
  const toPosition = breakers
    .map((el) => ({
      el,
      enabled: el.dataset[`${colKey}Enabled`] === 'true',
      index: parseInt(el.dataset[`${colKey}Index`], 10) || 0,
      span: parseInt(el.dataset[`${colKey}Span`], 10) || 1,
    }))
    .filter((b) => b.enabled)
    .sort((a, b) => a.index - b.index);

  toPosition.forEach(({ el: breaker, index, span }) => {
    breaker.style.gridColumn = `span ${span}`;

    // Build the item list at insertion time so already-placed breakers count.
    // The current breaker is still hidden at the end, so it is excluded.
    const allItems = [...grid.children].filter(
      (el) =>
        el.classList.contains('product-grid__item') ||
        (el.classList.contains('product-breaker') && el.style.display !== 'none')
    );
    // index is 1-based position the breaker occupies, so insert after item (index - 1)
    const clampedIndex = Math.min(index, allItems.length + 1);

    if (clampedIndex <= 1) {
      grid.insertBefore(breaker, grid.firstChild);
    } else {
      const afterItem = allItems[clampedIndex - 2];
      if (afterItem) {
        afterItem.insertAdjacentElement('afterend', breaker);
      } else {
        grid.appendChild(breaker);
      }
    }

    breaker.style.display = '';
  });
}

function initProductBreakers() {
  const grid = document.querySelector('.product-grid');
  if (!grid || !grid.querySelector('.product-breaker')) return;

  positionBreakers(grid);

  let rafId;
  let lastColCount = getColumnCount(grid);

  new ResizeObserver(() => {
    cancelAnimationFrame(rafId);
    rafId = requestAnimationFrame(() => {
      const colCount = getColumnCount(grid);
      if (colCount !== lastColCount) {
        lastColCount = colCount;
        positionBreakers(grid);
      }
    });
  }).observe(grid);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initProductBreakers);
} else {
  initProductBreakers();
}
